import { ReactNode } from "react";

// One responsive stat grid. Replaces per-page inline `gridTemplateColumns`
// objects and the ad-hoc `lg:grid-cols-4/5/6` logic.
const colsClass: Record<number, string> = {
  2: "sm:grid-cols-2",
  3: "sm:grid-cols-2 lg:grid-cols-3",
  4: "sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4",
  5: "sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5",
  6: "sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6",
};

export default function StatGrid({
  cols = 4,
  children,
  className = "",
}: {
  cols?: 2 | 3 | 4 | 5 | 6;
  children: ReactNode;
  className?: string;
}) {
  return <div className={`grid grid-cols-1 gap-4 md:gap-6 ${colsClass[cols]} ${className}`}>{children}</div>;
}
